import UserIcon from "../../assets/img/user-icon.svg";
import ExchangeIcon from "../../assets/img/exchange-icon.svg";
import useTranslator from "../../hooks/useTranslator";
import { useLocation, useNavigate } from "react-router-dom";
import { getGuarantorStatus, haveValue, toast } from "../../helper/common";
import DeleteConfiration from "./DeleteConfiration";
import { useContext, useState } from "react";
import TenantContext from "../../context/tenant/TenantContext";
import AuthContext from "../../context/auth/AuthContext";
import { BsThreeDotsVertical } from "react-icons/bs";

const EarnerCard = ({
  handleUpdateSource,
  userData,
  type,
  setUpdateSourceObj,
  allowViewProfile = true,
  showReportIcons = true,
  guarantorView = false,
  user,
  onClose = () => {},
  isDropdown,
  setIsDropdown,
  isEnabled,
  toggleIncomeSource,
  showIncomeSourceSelector,
  llShowOnly,
}) => {
  const { _t } = useTranslator();
  const navigate = useNavigate();
  const location = useLocation();
  const [showDeleteConfirmationPrompt, setShowDeleteConfirmationPrompt] =
    useState(false);
  const { removeGuarantor } = useContext(TenantContext);
  const [deleteGuarantorLoading, setDeleteGuarantorLoading] = useState(false);
  const { loadUser } = useContext(AuthContext);

  const checkGuarantorProfile = (guarantor_id) => {
    const fullPath = location.pathname + location.search;
    navigate(
      `${fullPath}${
        haveValue(location.search) ? "&" : "?"
      }guarantor=${guarantor_id}`
    );
  };

  const handleChangeSource = () => {
    handleUpdateSource();
    setUpdateSourceObj({
      _id: userData?.all_sources?._id,
      all_sources: userData?.all_sources,
      current_selected: userData?.source,
      current_income_mode: userData?.source_mode,
      type,
    });
  };

  const deleteGuarantor = async (_id) => {
    try {
      setDeleteGuarantorLoading(true);
      await removeGuarantor(_id);
      loadUser("tenant");
      setShowDeleteConfirmationPrompt(false);
    } catch (err) {
      toast.error(_t("failedToDeleteGuarantor"));
    } finally {
      setDeleteGuarantorLoading(false);
    }
  };

  return (
    <div
      className={`income-source-checkbox-card mb-3 ${
        showIncomeSourceSelector ? "income-source-card-wrapper" : ""
      } ${isEnabled ? "income-source-card-wrapper-active" : ""}`}
    >
      {showIncomeSourceSelector && (
        <label className="custom-gap-3 custom-checkbox">
          <input
            type="checkbox"
            onChange={() => toggleIncomeSource(userData?.all_sources?._id)}
            checked={isEnabled}
          />
          <span className="custom-checkmark"></span>
        </label>
      )}
      <div className="earner-card" style={{ width: "100%" }}>
        <div className="earner-info align-items-center justify-content-between gap-2 d-flex">
          <div className="align-items-center thumbnail-main-wrapper gap-2 d-flex">
            <div className="earner-thumbnail-wrapper">
              <img src={UserIcon} alt="User Icon" />
            </div>
            <div className="d-flex flex-column">
              <div className="d-flex align-items-center gap-2">
                <h4 className="earner-name">
                  {haveValue(userData?.all_sources?.name)
                    ? userData?.all_sources?.name
                    : type === "tenant" && haveValue(user)
                      ? `${user?.fname ?? ""} ${user?.lname ?? ""}`
                      : ""}
                </h4>
                <span className="earner-role">
                  {haveValue(userData?.gurantor_relation) &&
                    `${_t(userData?.gurantor_relation)} - `}
                  {_t(type)}
                </span>
              </div>
              <p className="earner-email">
                {userData?.all_sources?.user_email}
              </p>
            </div>
          </div>
          <div className=" d-flex align-items-center">
            {allowViewProfile &&
              showReportIcons &&
              (() => {
                const guarantorStatus = getGuarantorStatus(
                  "accepted",
                  userData?.all_sources
                );

                return (
                  <div
                    className="cursor-pointer"
                    onClick={(e) => {
                      if (
                        !llShowOnly ||
                        guarantorStatus?.status === "completed"
                      ) {
                        e.stopPropagation();
                        setIsDropdown(!isDropdown);
                      }
                    }}
                  >
                    {(!llShowOnly ||
                      guarantorStatus?.status === "completed") && (
                      <BsThreeDotsVertical className="btnSv" />
                    )}
                  </div>
                );
              })()}
            {type === "guarantor" && (
              <div className="position-relative">
                {isDropdown && (
                  <div className="editDeleteDropdown editDeleteDropdown2">
                    {(() => {
                      const guarantorStatus = getGuarantorStatus(
                        "accepted",
                        userData?.all_sources
                      );
                      return (
                        <p
                          onClick={() => {
                            onClose();
                            checkGuarantorProfile(userData?.all_sources?._id);
                          }}
                          className={`custom-gap-2 text-wraping ${guarantorStatus.status === "completed" ? "" : "d-none"}`}
                        >
                          <img
                            className=""
                            src="/images/viewIcon03.svg"
                            alt=""
                          />
                          {_t("viewProfile")}
                        </p>
                      );
                    })()}
                    {!llShowOnly && (
                      <p
                        className="deleteText custom-gap-2 text-wraping"
                        onClick={() => setShowDeleteConfirmationPrompt(true)}
                      >
                        <img src="/images/delete-icon.svg" alt="" />
                        {_t("delete")}
                      </p>
                    )}
                  </div>
                )}
              </div>
            )}
          </div>
        </div>
        <div className="income-source-wrapper">
          <div className=" d-flex align-items-center">
            {allowViewProfile &&
              showReportIcons &&
              (() => {
                const guarantorStatus = getGuarantorStatus(
                  "accepted",
                  userData?.all_sources
                );

                return (
                  <div
                    style={{
                      ...guarantorStatus.style,
                    }}
                    className={`viewMorebtn status-tile ${
                      guarantorStatus?.status === "completed" ? "" : ""
                    }`}
                  >
                    <p style={{ color: guarantorStatus.style.color }}>
                      {_t(guarantorStatus?.status)}
                    </p>
                    {guarantorStatus?.pendingFrom && (
                      <p
                        style={{ color: guarantorStatus.style.color2 }}
                        className="d-flex align-items-center"
                      >
                        <span
                          style={{
                            backgroundColor: guarantorStatus.style.color2,
                          }}
                          className="status-dot"
                        ></span>
                        {_t(guarantorStatus?.pendingFrom)}
                      </p>
                    )}
                  </div>
                );
              })()}
          </div>
          {/* <div className="income-source-main">
            <div className="income-source">
              <p>
                {_t("incomeSource")}:{" "}
                <span>
                  {Array.isArray(userData?.source) &&
                  userData?.source?.length > 0
                    ? userData.source
                        .map((src) => {
                          if (src?.startsWith?.("payslip:")) {
                            const temp = src.split(":");
                            const rawDate = temp[1]?.trim();

                            const parts = rawDate.split(" ");
                            let month = parts[0].replace(",", "");
                            const rest = parts.slice(1).join(" ");
                            const hasComma = parts[0].includes(",");

                            return `${_t(temp[0])}: ${_t(month)}${
                              hasComma ? "," : ""
                            }${rest ? " " + rest : ""}`;
                          }
                          return _t(src);
                        })
                        .join(", ")
                    : _t("noIncomeSelected")}
                </span>
              </p>
            </div>
            {showReportIcons &&
              llShowOnly &&
              !guarantorView &&
              haveValue(userData?.all_sources) && (
                <div className="re-do-icon-wrapper">
                  <img
                    src={ExchangeIcon}
                    alt=""
                    onClick={handleChangeSource}
                    style={{ cursor: "pointer" }}
                  />
                </div>
              )}
          </div> */}
          <h4 className="earning">€{userData?.amount}</h4>
        </div>
        <DeleteConfiration
          isOpen={showDeleteConfirmationPrompt}
          onClose={() => setShowDeleteConfirmationPrompt(false)}
          name={userData?.all_sources?.name ?? ""}
          relation={userData?.gurantor_relation ?? ""}
          heading={_t("deleteGuarantor")}
          description={_t("areYouSureDoYouWantToDeleteThisGuarantor")}
          btn1Text={_t("noGoBack")}
          btn2Text={_t("yesDelete")}
          btn1Functionality={() => setShowDeleteConfirmationPrompt(false)}
          btn2Functionality={() => deleteGuarantor(userData?.all_sources?._id)}
          submitLoading={deleteGuarantorLoading}
        />
      </div>
    </div>
  );
};

export default EarnerCard;
